<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
<!--        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">-->
<!--          <div class="grid_sub_half">-->
<!--            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ OR-12390821390</b></div>-->
<!--            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>-->
<!--            &lt;!&ndash;            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: grey">รอการลูกค้าชำระเงิน</b></div>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกหนี้</b></div>
            <div class="grid_half_content">
              <div class="mt-2">
                <div class="ml-1 mr-3">ชื่อ : {{header_data.name}}</div>
              </div>
              <div class="mt-2">
                <div class="ml-1 mr-3">เบอร์โทร : {{header_data.telephone}}</div>
              </div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ยอดเครดิตของลูกหนี้</b></div>
            <div class="grid_half_content">
              <div class="mt-2">
                <div class="ml-1 mr-3">ยอดเครดิตสูงสุดที่สั่งซื้อได้ : <span style="color: #86bc3a;">{{ format_price(header_data.credit) }}</span></div>
              </div>
              <div class="mt-2">
                <div class="ml-1 mr-3">ยอดค้างชำระทั้งหมด : <span style="color: red;">{{ format_price(header_data.credit_remain) }}</span></div>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการ</b></div>
              <template>
                <v-expansion-panels v-model="panel" :disabled="disabled">

                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl" v-for="(item, index) in order_list" :key="index">
                    <v-expansion-panel-header>
                      <div class="grid_three font_size_grid">
                        <div>เลขที่ : {{item.order_code}}</div>
                        <div class="sub_grid_three">
                          <div>วันที่สั่งซื้อ {{ item.created_at }} </div>
                          <div>ยอดการสั่งซื้อ : {{format_price(item.total)}} บาท</div>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="ma-2">
                        <div class="font_size_grid mb-1">
                          <div>ผู้รับ : {{item.name}} ({{item.telephone}})</div>
                        </div>
                        <div class="font_size_grid mb-1">
                          <div>ที่อยู่ : {{item.address}}</div>
                        </div>
                        <div class="mt-3">
                          <v-divider/>
                          <v-data-table class="color_table_1" :headers="headers" :items="item.list" :footer-props="footer_Props" mobile-breakpoint="0">
                            <template v-slot:item="dataDetail">
                              <tr>
                                <td class="pa-3">
                                  <div class="image_grid">
                                    <div class="mx-auto">
                                      <v-img height="64" width="64" max-width="64" v-if="dataDetail.item.picture !== null" :lazy-src="picture_product" :src="dataDetail.item.picture" class="preview mx-auto"></v-img>
                                      <v-img height="64" width="64" max-width="64" v-else :lazy-src="picture_product" :src="picture_product" class="preview mx-auto"></v-img>
                                    </div>
                                    <div class="pa-2 pt-4 font_mobile">{{ dataDetail.item.name }}</div>
                                  </div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetail.item.cost) }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_number(dataDetail.item.quantity) }} {{ dataDetail.item.unit_name }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetail.item.total) }}</div>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:body.append>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>ค่าจัดส่ง</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_number(item.delivery_price) }}</b></td>
                              </tr>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>รวม</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_price(item.total) }}</b></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

<!--                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl">-->
<!--                    <v-expansion-panel-header>-->
<!--                      <div class="grid_three font_size_grid">-->
<!--                        <div>เลขที่ : OR6500001</div>-->
<!--                        <div class="sub_grid_three">-->
<!--                          <div>วันที่สั่งซื้อ 15 มีนาคม 2565 </div>-->
<!--                          <div>ยอดการสั่งซื้อ : 1,278.00 บาท</div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </v-expansion-panel-header>-->
<!--                    <v-expansion-panel-content>-->
<!--                      Some content-->
<!--                    </v-expansion-panel-content>-->
<!--                  </v-expansion-panel>-->

                </v-expansion-panels>
              </template>
            </div>
          </v-card>
        </div>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_number(100.32) }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail(0)" class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct" class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_product from "@/assets/pill.png";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Report_debtor_detail",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_product: picture_product,
      imagePreviewURL: null,
      perPage: -1,
      image_modal: false,
      order_number: '',
      panel: 0,
      disabled: false,
      readonly: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header_data: [],
      order_list: [],
      headers: [
        {
          text: 'รายการสินค้าส่งคืน',
          value: '',
          fixed: true,
          sortable: false,
          width: '300px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'รวม',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
      ],
      data_list: [
        {
          id: 1,
          product_name: 'tab.POLIDENT Pro Retainer 30 tab 189.-',
          price: '189.00',
          quantity: '2',
          unit_name: 'กล่อง',
          total: '378.00',
        },
      ],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.get('debtors/detail/' + this.$route.params.id)
          .then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false
          this.header_data = res.data.debtor
          this.order_list = res.data.orders
          console.log(res.data)
        }
      })
    },
    get_edit() {
      const id = 1
      this.$router.push('/sell/ordercustomeredit/' + id)
    },
    confirm_detail() {
      this.$router.push('/creditor/transfercorrect/' + this.$route.params.id)
    },
    in_correct() {
      const id = 1
      this.$router.push('/creditor/transferincorrect/' + id)
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_half_content {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.mobile_btn {
  width: 50%;
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
.mobile_grid {
  width: 25%
}
.grid_three {
  display: grid;
  grid-template-columns: 30% 70%;
}
.sub_grid_three {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.color_table_1 >>> thead {
  background-color: #E2F5C7 !important;
}
.image_grid {
  display: grid;
  grid-template-columns: 15% 85%;
}
.font_size_grid {
  font-size: 18px !important;
}
@media only screen and (max-width: 1180px) {
  .grid_three {
    display: grid;
    grid-template-columns: 25% 65%;
  }
  .font_size_grid {
    font-size: 14px !important;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 32%
  }
  .image_grid {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .font_mobile {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 500px) {
  .grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .font_size_grid {
    font-size: 16px !important;
  }
  .sub_grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_half_content {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 5px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_btn {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
}
</style>
